import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

export const OverviewSection = ({ onContactClick }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-emerald-50 to-amber-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">
            What is Trademark Registration?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Understanding the importance and benefits of federal trademark protection for your business.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <Card className="border-emerald-200 shadow-xl">
            <CardContent className="p-8 md:p-12">
              <div className="space-y-6">
                <p className="text-lg text-gray-700 leading-relaxed">
                  A <strong className="text-emerald-800">trademark</strong> is a unique identifier—such as a word, phrase, symbol, design, or combination thereof—that distinguishes your goods or services from those of competitors. Federal trademark registration with the <strong className="text-emerald-800">United States Patent and Trademark Office (USPTO)</strong> grants you exclusive nationwide rights to use that mark in connection with your business.
                </p>

                <p className="text-lg text-gray-700 leading-relaxed">
                  Trademark registration provides <strong className="text-emerald-800">legal protection</strong> for your brand identity, preventing others from using confusingly similar marks that could mislead consumers or dilute your brand value. It's a critical step in building a strong, defensible brand that can grow and thrive in competitive markets.
                </p>

                <div className="bg-emerald-50 rounded-xl p-6 border-l-4 border-emerald-600 my-8">
                  <h4 className="text-xl font-bold text-emerald-900 mb-3">Why Register Your Trademark?</h4>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-amber-600 font-bold mr-2">•</span>
                      <span><strong>Exclusive Rights:</strong> Gain nationwide exclusive rights to use your mark in your industry</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-amber-600 font-bold mr-2">•</span>
                      <span><strong>Legal Presumption:</strong> Federal registration provides legal presumption of ownership and validity</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-amber-600 font-bold mr-2">•</span>
                      <span><strong>Infringement Protection:</strong> Sue infringers in federal court and recover damages</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-amber-600 font-bold mr-2">•</span>
                      <span><strong>Brand Value:</strong> Registered trademarks are valuable assets that increase business valuation</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-amber-600 font-bold mr-2">•</span>
                      <span><strong>® Symbol:</strong> Use the ® symbol to signal your registered status and deter copycats</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-amber-600 font-bold mr-2">•</span>
                      <span><strong>E-Commerce Protection:</strong> Protect your brand on Amazon, eBay, and other marketplaces</span>
                    </li>
                  </ul>
                </div>

                <p className="text-lg text-gray-700 leading-relaxed">
                  Without federal registration, your trademark rights are limited to the geographic areas where you actually use the mark. Federal registration extends your protection nationwide and provides significantly stronger legal remedies against infringement, making it an essential investment for any serious business.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
                  <Button
                    onClick={onContactClick}
                    size="lg"
                    className="bg-emerald-700 hover:bg-emerald-800 text-white font-semibold px-8 transition-all duration-300"
                  >
                    Protect My Brand Now
                  </Button>
                  <Button
                    onClick={onContactClick}
                    size="lg"
                    variant="outline"
                    className="border-2 border-amber-600 text-amber-700 hover:bg-amber-50 font-semibold px-8 transition-all duration-300"
                  >
                    Free Trademark Consultation
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
